"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M5.8.3l-.9.9 2.1 2H0v1.3h7L4.9 6.6l.9.9 2.7-2.7c.3-.3.4-.6.4-1s-.1-.7-.4-1L5.8.3z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M19 3.2h-7l2.1-2.1-.9-.9-2.7 2.7c-.3.3-.4.6-.4 1s.1.7.4 1l2.7 2.7.9-.9L12 4.5h7V3.2z"
})), {
  viewBox: '0 0 19 8',
  width: 19,
  height: 8
});
module.exports = exports.default;